import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`font-mono-alt text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] ${className}`}
  >
    {children}
  </p>
);

export const SectionHead = ({ overline, title, testId }) => (
  <div className="mb-14 md:mb-20">
    <Reveal>
      <Overline>{overline}</Overline>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        data-testid={testId}
        className="mt-4 font-serif text-3xl tracking-tight text-[#F7F5F0] sm:text-4xl lg:text-5xl"
      >
        {title}
      </h2>
    </Reveal>
  </div>
);

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const engageService = (title) => {
  window.dispatchEvent(new CustomEvent("byot:preselect-service", { detail: title }));
  scrollToId("#contact");
};

export const GOLD = "#D4AF37";
export const EASE_OUT = EASE;
